import React from 'react';
import { Box, Avatar, ListItemText, ListItemAvatar } from '@mui/material';
import { capitalizeFirstLetter } from '../utils/lib';

const ListItemWAvatar = ({ primary, secondary, thumbUrl, size = 'medium', defaultIcon }) => {  

  const avatarContent = defaultIcon || capitalizeFirstLetter(primary?.charAt(0) || '');

  return (
    <Box display="flex" alignItems="center" width="100%">
      <ListItemAvatar>
        <Avatar 
          alt={capitalizeFirstLetter(primary)} 
          src={thumbUrl}
          sx={{ width: size === 'small' ? 32 : size === 'large' ? 56 : 40, 
                height: size === 'small' ? 32 : size === 'large' ? 56 : 40 }}>
            {!thumbUrl && avatarContent}
        </Avatar>

      </ListItemAvatar>
      <ListItemText 
        primary={primary} 
        secondary={secondary || ''} 
        // sx={{ marginLeft: 0 }} // Espacio entre el avatar y el texto
      />
    </Box>
  );
};

export default ListItemWAvatar;


